import React, { useEffect } from 'react'
import { Card, CardHeader, CardContent, TextField, Typography, MenuItem, ListItemText } from '@material-ui/core'

import { makeStyles } from '@material-ui/core/styles'

import { states } from '../../services/helpers'
import { useSelector, useDispatch } from 'react-redux'
import { getMarkets } from '../../actions/markets/markets.actions'
import Autocomplete from '@material-ui/lab/Autocomplete'

const useStyles = makeStyles((theme) => ({
	formWrapper: {
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'space-between'
	},
	fieldWrapper: {
		marginBottom: '20px',
		'& .MuiTextField-root': {
			minWidth: '275px'
		}
	},
	autoComplete: {
		'& .MuiFilledInput-root': {
			paddingTop: '17px'
		},
		'& .MuiInputLabel-filled': {
			transform: 'translate(12px, 20px) scale(1)'
		},
		'& .Mui-focused': {
			'& .MuiAutocomplete-endAdornment svg': {
				fill: theme.palette.secondary.main
			}
		},
		'& .MuiAutocomplete-endAdornment svg': {
			fill: '#777679'
		}
	}
}))

const AddressForm = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()

	const markets = useSelector((state) => state.specific.markets.markets)
	const loading = useSelector((state) => state.specific.markets.loading)
	const marketsLoading = useSelector((state) => state.specific.markets.loading)

	let { client, setClient } = props

	// Load the markets once. This ran after every render, so a failed load retried on each one.
	useEffect(() => {
		if (!markets && !loading) {
			dispatch(getMarkets())
		}
	}, [])

	useEffect(() => {
		if (markets && markets.length && !client.market) {
			let market = markets.find((m) => m.city === 'Charlotte')

			setClient({
				...client,
				market
			})
		}
	}, [markets, client.market])

	useEffect(() => {
		if (states && !client.contact.address.state) {
			updateAddress(
				'state',
				states.find((s) => s.id === 33)
			)
		}
	}, [states])

	const updateAddress = (field, value) => {
		let { address } = client.contact
		let updated = { ...address }

		updated[field] = value

		setClient({
			...client,
			contact: {
				address: updated
			}
		})
	}

	return (
		<Card style={{ marginTop: '24px', marginBottom: '24px' }}>
			<CardHeader title="Location" />
			<CardContent>
				<Typography variant="body2" style={{ fontWeight: 800, marginBottom: '16px' }}>
					Address
				</Typography>
				<div className={classes.formWrapper}>
					<div className={classes.fieldWrapper}>
						<TextField
							variant="filled"
							select
							value={client.market}
							label="Market"
							disabled={marketsLoading}
							onChange={(e) =>
								setClient({
									...client,
									market: e.target.value
								})
							}>
							{markets && markets.length > 0 ? (
								markets.map((market) => (
									<MenuItem key={market._id} value={market}>
										{market.city}
									</MenuItem>
								))
							) : (
								<MenuItem>No Markets</MenuItem>
							)}
						</TextField>
					</div>
					<div className={classes.fieldWrapper}>
						<TextField
							id="household-select"
							variant="filled"
							label="Address"
							value={client.contact.address.address_1}
							onChange={(e) => updateAddress('address_1', e.target.value)}
						/>
					</div>
					<div className={classes.fieldWrapper}>
						<TextField
							id="household-select"
							variant="filled"
							label="Address 2"
							value={client.contact.address.address_2}
							onChange={(e) => updateAddress('address_2', e.target.value)}
						/>
					</div>
					<div className={classes.fieldWrapper}>
						<TextField
							id="household-select"
							variant="filled"
							label="City"
							value={client.contact.address.city}
							onChange={(e) => updateAddress('city', e.target.value)}
						/>
					</div>
					<div className={classes.fieldWrapper}>
						<Autocomplete
							size="small"
							getOptionLabel={(option) => option.name}
							id="household-select"
							className={classes.autoComplete}
							options={states || []}
							value={client.contact.address.state}
							onChange={(e, v) => updateAddress('state', v)}
							onClose={(e) => {
								e.target.value = ''
							}}
							renderOption={(option) => (
								<React.Fragment>
									<ListItemText primary={option.name} />
								</React.Fragment>
							)}
							renderInput={(params) => <TextField {...params} variant="filled" label="State" />}
							onKeyPress={(e, v) => (e.key === 'Enter' ? updateAddress('state', v) : null)}
						/>
					</div>
					<div className={classes.fieldWrapper}>
						<TextField
							id="household-select"
							variant="filled"
							label="Zipcode"
							value={client.contact.address.zip_code}
							onChange={(e) => updateAddress('zip_code', e.target.value)}
						/>
					</div>
				</div>
			</CardContent>
		</Card>
	)
}

export default AddressForm
